import { render } from "./KontoErstellenProcess.vue?vue&type=template&id=29bd1eaf"
import script from "./KontoErstellenProcess.vue?vue&type=script&lang=js"
export * from "./KontoErstellenProcess.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__